import { ReactElement, ReactNode } from 'react'
import { TextGradient } from '../../../../components/textGradient/TextGradient'
import styles from './StatisticView.module.css'
export const StatisticItemMain = ({activityImg, distance, name, activity}:{activityImg:ReactElement|ReactNode,distance:string,name:string,activity:string}) =>{
    return(
        <div className={styles.statisticView_item_container}>
            <div className={styles.statisticView_item_main_container}>
                <div className={styles.statisticView_text_gradient}>Самая длинная дистанция</div>
                <div className={styles.statisticView_item_distance}>
                    <div>{activityImg}</div>
                    <div style={{display:"flex", flexDirection:"row", alignItems:"center",gap:"3px"}}>
                        <div style={{fontSize:"16px", fontWeight:"700"}}>{distance}</div>
                        <div>{activity.includes('SWIMMING')?"М":"КМ"}</div>
                    </div>
                </div>
                <div className={styles.statisticView_item_fio}>
                    {name.split(" ").map((x)=>{return <div>{x}</div>})}
                </div>
            </div>
        </div>
    )
}